







































































































































import { Component, Vue } from 'vue-property-decorator';
import User from '@/models/User';
import get from 'lodash/get';
import { postRegisterPrescriber } from '@/api/api';
import AuthModule from '@/store/AuthModule';
import router from '@/router';
import ButtonLoading from '@/components/ButtonLoading.vue';
import SmoothReflow from '@/components/SmoothReflow.vue';
import CGVPopup from '@/components/CGVPopup.vue';

type UserCivility = 'Monsieur' | 'Madame';

@Component({
    components: {
        SmoothReflow,
        ButtonLoading,
        CGVPopup,
    },
})
export default class Login extends Vue {
    civility: UserCivility | null | undefined = null;
    lastname: string = '';
    firstname: string = '';
    company: string = '';
    email: string = '';
    password: string = '';
    errors: any = null;
    submit: boolean = false;
    loading: boolean = false;
    showMessage: boolean = false;
    smoothReflowSettings = {
        transitionEvent: {
            selector: 'div',
            propertyName: 'height',
        },
    };
    termsAndConditions: boolean = false;
    popupCGV: boolean = false;

    created() {
        this.civility = undefined;
    }

    get civilityValid(): boolean {
        return this.civility !== null && this.civility !== undefined;
    }

    get lastnameValid(): boolean {
        return this.lastname !== '';
    }

    get firstnameValid(): boolean {
        return this.firstname !== '';
    }

    get companyValid(): boolean {
        return this.company !== '';
    }

    get emailValid(): boolean {
        return this.email !== '';
    }

    get passwordValid(): boolean {
        return this.password !== '';
    }

    async onSubmit() {
        this.submit = true;
        const $vs = (this as any).$vs;
        const errorMessage = 'Veuillez corriger les erreurs';

        if (
            !this.civilityValid ||
            !this.lastnameValid ||
            !this.firstnameValid ||
            !this.companyValid ||
            !this.emailValid ||
            !this.passwordValid
        ) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: errorMessage,
            });
            return;
        }

        if (!this.termsAndConditions) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Veuillez accepter les conditions générales de ventes',
            });
            return;
        }

        if (this.civility) {
            const request = {
                civility: this.civility,
                firstname: this.firstname,
                lastname: this.lastname,
                company: this.company,
                email: this.email,
                password: this.password,
            };

            try {
                this.loading = true;
                const resp = await postRegisterPrescriber(request);

                this.showMessage = true;
            } catch (error) {
                this.errors = error.response.data.errors;

                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: errorMessage,
                });
            } finally {
                this.loading = false;
            }
        }
    }

    getErrors(field: string): string[] {
        return get(this.errors, `children.${field}.errors`, []);
    }

    get userCivilities() {
        return new Set<UserCivility>(['Monsieur', 'Madame']);
    }
}
